import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';
import { toast } from 'react-toastify';

/**
 * Obtiene el listado de informes generados y el resumen de almacenamiento.
 * @returns {Promise<{success: boolean, data: Array, summary: Object} | null>}
 */
export async function getGeneratedReportsList() {
  try {
    const response = await getAPIResponse('/v1/admin/reports', {}, 'GET');
    return response;
  } catch (error) {
    toast.error('Error al obtener la lista de informes generados');
    return null;
  }
}

/**
 * Elimina un informe generado en el servidor por su nombre de archivo.
 * @param {string} filename
 * @returns {Promise<{success: boolean, message: string} | null>}
 */
export async function deleteGeneratedReport(filename) {
  if (!filename) return null;
  try {
    const response = await getAPIResponse(`/v1/admin/reports/${encodeURIComponent(filename)}`, {}, 'DELETE');
    return response;
  } catch (error) {
    toast.error('Error al eliminar el informe');
    return null;
  }
}

/**
 * Descarga el informe generado como blob autenticado con su nombre original.
 * @param {string} filename
 * @returns {Promise<boolean>}
 */
export async function downloadGeneratedReport(filename) {
  if (!filename) return false;
  try {
    const response = await getAPIResponse(
      `/v1/admin/reports/${encodeURIComponent(filename)}/download`,
      {},
      'GET',
      true,
      'blob'
    );

    if (!response || !response.data) {
      toast.error('No se pudo descargar el archivo solicitado.');
      return false;
    }

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    toast.success(`Descarga iniciada: ${filename}`);
    return true;
  } catch (error) {
    toast.error('Error al descargar el archivo.');
    return false;
  }
}
